import React, { useEffect, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.scss"
import "./styles.scss"
const ServicesList = ({ services, isDesktop }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true)
  }, [])
  return (
    <ul className={`services ${isLoaded ? "isMobile" : ""}`}>
      {isDesktop && (
        services.map((service, i) => {
          return (
            <li key={i} className="service">
              {service}
            </li>
          )
        })
      )}
      {!isDesktop && (
        <Swiper freeMode slidesPerView="auto" spaceBetween={16}>
          {services.map((service, i) => {
            return (
              <SwiperSlide key={i}>
                <li className="service">{service}</li>
              </SwiperSlide>
            )
          })}
        </Swiper>
      )}
    </ul>
  )
}

export default ServicesList
